// extracted by mini-css-extract-plugin
export default {"dialog-content":"CommonDialog_dialog-content__BjygK"};